import { YES_NO } from '../types';
export const SWEDEN_REGEX = /^((((0{2}?)|(\+){1})46)|0)7[\d]{8}$/;
export const appText: Record<string, string> = {
  labelName: 'Namn *',
  labelNumber: 'Mobil *',
  labelFormHeader: 'Är du kund hos oss idag? *',
  labelPersonalNumber: 'Personnummer',
  placeholderPersonalNumber: 'ÅÅÅÅMMDDNNNN',
  formOptionYes: 'Ja',
  formOptionNo: 'Nej',
  callButton: 'Ring upp mig',
  formLabelOptionsCustomer: 'Vad kan vi hjälpa dig med? *',
  formYesOptionResponse1: 'Köpa försäkring',
  formYesOptionResponse2: 'Avsluta försäkring',
  formYesOptionResponse3: 'Personförsäkring',
  formOtherResponse: 'Övriga frågor',
  formYesOtherResponsePlaceholder: 'Berätta gärna vad vi kan hjälpa dig med',
  errorTextAll: 'Fältet är obligatoriskt',
  titleInitial: 'Är du rätt försäkrad?',
  descInitial:
    'Vi ringer upp dig och går igenom ditt försäkringsbehov. Fyll i uppgifterna nedan så återkommer vi till dig under våra öppettider, måndag till fredag mellan 8.30 och 17.',
  titleSuccess: 'Tack!',
  descSuccess: 'Vi kommer att ringa upp dig inom kort.',
  errorTextSSN: 'Personnummer är inte korrekt.',
  keyCallMeOk: 'Vi ringer upp dig senast nästa vardag.',
  keyCallMeError: 'Hoppsan, vi verkar ha teknikstrul för tillfället.',
  keyAlreadyRegistered:
    'Vi har redan registrerat din förfrågan om att bli uppringd.',
  keyInvalidPhone:
    'Ange mobilnumret med 10 siffror och utan bindestreck eller mellanslag.',
  keyClosed: 'Du har kontaktat oss utanför våra öppettider.',
  keyFailureDesc: 'Försök lite senare eller ring kundservice på 0771-326 326',
  keyErroButtonText: 'Försök igen',
  urlErrorImage:
    'https://gjepublictestsa.blob.core.windows.net/claims-sweden/sweden-core/images/ManInRain_detailed.svg'
};

export const customerSelectionOptions = [
  {
    label: appText['formOptionYes'],
    value: YES_NO.yes
  },
  {
    label: appText['formOptionNo'],
    value: YES_NO.no
  }
];

export interface QueueDetailsType {
  errand: string;
  menuchoice: string;
  entrance: string;
}

export const getQueueDetails = () => {
  let details: QueueDetailsType;
  if (window.location.hostname === 'www.gjensidige.se') {
    details = {
      errand: '670',
      menuchoice: 'SE_WCB_Ringmig',
      entrance: 'Webb'
    };
  } else {
    details = {
      errand: '375',
      menuchoice: 'NO_WCB_Privat',
      entrance: 'Webb'
    };
  }
  return details;
};
